export default () => [
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 130,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },

  {
    field: 'sortOrder',
    align: 'center',
    width: 60,
    fixed: 'left',
    title: '顺序',
  },
  {
    field: 'linePointTypeName',
    align: 'center',
    width: 100,
    title: '类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'linePointName',
    align: 'left',
    width: 100,
    title: '名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'custName',
    align: 'left',
    width: 100,
    title: '客户',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'provinceName',
    align: 'left',
    width: 100,
    title: '省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'cityName',
    align: 'left',
    width: 100,
    title: '城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'districtName',
    align: 'left',
    width: 100,
    title: '区县',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'linePointAddress',
    align: 'left',
    width: 130,
    title: '详细地址',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
//   {
//     field: 'distance',
//     align: 'center',
//     width: 100,
//     title: '节点距离',
//     showHeaderOverflow: 'title',
//     showOverflow: 'ellipsis',
//     sortable: true,
//   },
  {
    field: 'linePointStatusName',
    align: 'center',
    width: 80,
    title: '有效状态',
    slots: { default: 'status' },
  },
  {
    field: 'createTime',
    title: '创建时间',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
]
